import React from 'react';
import { useTranslation } from 'react-i18next';
import { Lock, Check, Star } from 'lucide-react';

const CAT_ORDER = ['Fundamentals', 'Control', 'Jumps', 'Rotations', 'Style', 'Freestyle', 'Big Air'];

export const SkillTree = ({ nodes = [] }) => {
  const { t } = useTranslation();
  const byCat = {};
  nodes.forEach((n) => { (byCat[n.category] = byCat[n.category] || []).push(n); });
  const cats = CAT_ORDER.filter((c) => byCat[c]);

  return (
    <div className="space-y-6" data-testid="skill-tree">
      {cats.map((cat) => (
        <div key={cat}>
          <div className="label-eyebrow text-muted-foreground mb-3">{t(`skillTree.categories.${cat}`, { defaultValue: cat })}</div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
            {byCat[cat].map((n) => (
              <div key={n.key} data-testid={`skill-node-${n.key}`}
                className={`relative rounded-xl p-4 border transition-all ${n.unlocked
                  ? 'border-[#00B4D8]/40 bg-[#0E1114]'
                  : 'border-white/8 bg-[#0E1114]/60'}`}>
                <div className="flex items-center justify-between">
                  <span className={`text-sm font-semibold ${n.unlocked ? 'text-white' : 'text-muted-foreground'}`}>{n.label}</span>
                  {n.unlocked
                    ? <span className="w-6 h-6 rounded-full bg-[#00B4D8]/15 flex items-center justify-center"><Check className="w-3.5 h-3.5 text-[#00B4D8]" /></span>
                    : <Lock className="w-4 h-4 text-muted-foreground" />}
                </div>
                <p className="text-xs text-muted-foreground mt-1.5 leading-snug">{n.description}</p>
                {n.unlocked && n.best_score != null && (
                  <div className="mt-2 flex items-center gap-1 font-data text-xs text-[#48CAE4]">
                    <Star className="w-3 h-3" /> {t('skillTree.best')} {n.best_score}/10
                  </div>
                )}
                {n.premium && !n.unlocked && (
                  <span className="absolute top-2 right-8 label-eyebrow text-[#FF6B35] text-[9px]">{t('skillTree.pro')}</span>
                )}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
